import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";

const UpdateUsername = () => {
  let userData = JSON.parse(localStorage.getItem("userData"));
  // let userDataName;
  const token = localStorage.getItem("token");
  const [closeUsernamePopup, setCloseUsernamePopup] = useState(false);
  const [oldUsername, setOldUsername] = useState(userData?.name);
  const [NewUsername, setNewUsername] = useState("");
  const closeBox = () => {
    setCloseUsernamePopup(!closeUsernamePopup);
  };
useEffect(() => {
  

  return () => {
    console.log("State Updated")
  let userData = JSON.parse(localStorage.getItem("userData"));
  // window.reload()
  

  }
}, [localStorage.getItem("userData")])

  const updateName = () => {
    try {
      axios
        .put(
          `${process.env.REACT_APP_SERVER_URL}/user-name`,
          {
            email: userData.email,
            name: NewUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          // localStorage.setItem("userDataName", NewUsername);
          // userDataName = localStorage.getItem("userDataName");
          userData.name= NewUsername;
          console.log(userData);
          localStorage.setItem("userData", JSON.stringify(userData));
          
          closeBox();
          window.location.reload()
          // console.log("aaaaaaa", userDataName);
        });
    } catch (error) {
      console.error(error);
    }
  };
  
  
console.log("NewUserName",NewUsername)
  return (
    <div className=" md:my-auto">
      <div className="">
        <span className="font-medium text-xl">Username</span>
        <div className="flex items-center px-2 gap-4 font-bold text-lg mb-5 text-slate-400">
        {/* {userDataName? userDataName: userData?.name} */}
        {userData?.name}
          <span
            onClick={() => setCloseUsernamePopup(true)}
            className="text-xl hover:animate-pulse"
          >
            <FaEdit />
          </span>
        </div>
      </div>
      {closeUsernamePopup && (
        <div
          className={"px-2 relative z-50 "}
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div
            className={`fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity`}
          ></div>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center ">
              <div
                className={`relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2`}
              >
                <div
                  className={`bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2`}
                >
                  <div className="sm:flex sm:items-start">
                    <div className={`p-2 `}>
                      <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                        Update Username
                      </h3>
                      <div>
                        <label
                          htmlFor="username"
                          className="block mt-2 text-sm text-left font-medium text-white dark:text-white"
                        >
                          Enter New Username
                        </label>
                        <input
                          type="text"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                          placeholder="Enter New Username"
                          required
                          onChange={(e) => setNewUsername(e.target.value)}
                        />
                      </div>

                      <button
                        className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        onClick={updateName}
                      >
                        Update Username
                      </button>
                    </div>
                  </div>
                </div>
                <button
                  onClick={closeBox}
                  type="button"
                  className="mx-4 mb-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateUsername;
